window.Vue = require('vue');
import Router from './routes.js'


Vue.config.productionTip = false;

const app = new Vue({
    el: '#app',
    router:Router
});
